<script>
export default {
  name: 'BaseTableFooter',
  props: {
    showItemsPerPageSelector: { type: Boolean, default: false },
    itemsPerPageModel: { type: Number, default: 10 },
    itemsPerPageOptions: { type: Array, default: () => [10, 25, 50, 100] },
    footerSummary: { type: String, default: '' },
    paginationData: {
      type: Object,
      default: () => ({ page: 1, pageCount: 1, itemsLength: 0 }),
    },
  },
  computed: {
    // `-1` (convenção do v-data-table = "mostrar todos") aparece como "Todos" no
    // seletor, mantendo o VALOR numérico emitido no @change. Objetos {text,value}
    // preservam o template PADRÃO do v-select (estilo do v-list-item) — um slot
    // `item` custom quebrava o visual das opções.
    selectOptions() {
      return this.itemsPerPageOptions.map((n) =>
        n === -1 ? { text: 'Todos', value: -1 } : { text: String(n), value: n }
      )
    },
  },
}
</script>

<template>
  <div class="base-table__footer">
    <div class="base-table__footer-left d-flex align-center az-gap-small">
      <div
        v-if="showItemsPerPageSelector"
        class="base-table__page-size d-flex align-center"
      >
        <span class="base-table__footer-info az-ds-aux">Mostrar</span>
        <v-select
          :value="itemsPerPageModel"
          :items="selectOptions"
          :menu-props="{ offsetY: true }"
          class="base-table__page-size-select az-ds-aux"
          hide-details
          dense
          @change="$emit('change-items-per-page', $event)"
        />
        <span class="base-table__footer-info az-ds-aux">·</span>
      </div>
      <span class="base-table__footer-info base-table__summary az-ds-aux">
        {{ footerSummary }}
      </span>
    </div>
    <v-pagination
      v-if="paginationData.pageCount > 1"
      :value="paginationData.page"
      :length="paginationData.pageCount"
      :total-visible="5"
      color="black"
      class="base-table__pagination"
      @input="$emit('go-to-page', $event)"
    />
  </div>
</template>

<style scoped lang="sass">
.base-table__footer
  display: flex
  align-items: center
  justify-content: space-between
  gap: 16px
  margin-top: 16px

.base-table__footer-info
  color: var(--neutral-700)
  white-space: nowrap

.base-table__footer-left
  min-width: 0

.base-table__page-size
  gap: 6px

.base-table__page-size-select
  flex: 0 0 auto
  max-width: 72px
  margin-top: 0 !important
  padding-top: 0 !important

  ::v-deep .v-input__control
    min-height: 28px !important
    height: 28px

  ::v-deep input
    padding: 0 !important

  ::v-deep .v-input__slot
    min-height: 28px !important
    height: 28px !important
    margin-bottom: 0 !important
    padding: 0 8px !important
    border: 1px solid var(--border-hairline) !important
    border-radius: var(--radius-md)
    box-shadow: none !important
    align-items: center !important

  ::v-deep .v-text-field__details
    display: none !important

  ::v-deep .v-select__selections
    min-height: 28px !important
    height: 28px !important
    align-items: center !important

  ::v-deep .v-input__slot::before,
  ::v-deep .v-input__slot::after
    display: none

  ::v-deep .v-select__selection
    color: var(--neutral-700)
    font-size: 13px
    line-height: 28px
    padding-top: 0
    padding-bottom: 0

  ::v-deep .v-input__append-inner
    margin-top: 0 !important
    align-self: center !important

  ::v-deep .v-select__selection--comma
    margin-top: 0
    margin-bottom: 0
    line-height: 28px

  ::v-deep .v-input__append-inner
    margin-top: 0 !important
    align-self: center

  ::v-deep .v-icon
    font-size: 18px
    color: var(--neutral-700)

.base-table__pagination
  flex: 0 0 auto
  width: auto
  box-shadow: none
  justify-content: flex-end

  ::v-deep > li
    margin-right: 2px !important

  ::v-deep .v-pagination__item,
  ::v-deep .v-pagination__navigation
    box-shadow: none
    border-radius: var(--radius-md)
    min-width: 28px
    width: 28px
    height: 28px
    margin-right: 0
    font-size: 13px
    font-weight: 500

  ::v-deep .v-pagination__item
    background: transparent
    color: var(--neutral-700)

  ::v-deep .v-pagination__item--active
    color: var(--white) !important

  ::v-deep .v-pagination__navigation
    background: transparent
    border: 1px solid var(--border-hairline)

    .v-icon
      font-size: 18px

  ::v-deep .v-pagination__more
    display: flex
    align-items: center
    height: 28px
    min-width: 14px
    margin: 0
    color: var(--neutral-700)
</style>
